import MetricBase from "models/metrics/MetricBase";
import PercentUnit from "models/metrics/unit/PercentUnit";
import i18n from "i18next";
import VisibilityGroup from "../../../../groups/VisibilityGroup";

class MetricImprShare extends MetricBase {
    constructor() {
        super({
            field: "metric_impr_share_trivago",
            defaultVisibility: true,
            unit: new PercentUnit(),
            chartName: i18n.t("metrics.trivago.imprShare.chartName"),
            serieLabel: i18n.t("metrics.trivago.imprShare.serieLabel"),
            tooltip: i18n.t("metrics.trivago.imprShare.tooltip"),
            group: new VisibilityGroup(),
        });
    }
}

export default MetricImprShare;
